export const MANY_INVITES_PARTNER_ID = 'mockManyPartnerId'
export const FEW_INVITES_PARTNER_ID = 'mockFewPartnerId'
export const ONE_INVITES_PARTNER_ID = 'mockOnePartnerId'
export const NONE_INVITES_PARTNER_ID = 'mockNonePartnerId'
export const ERROR_PARTNER_ID = 'mockErrorPartnerId'
export const DUMMY_INVITEE_NAME = 'John Doe'
export const DUMMY_INVITEE_EMAIL = 'JohnDoe@amazon.com'
export const DUMMY_INVALID_INVITEE_EMAIL = 'JohnDoe@amazon.com k'
export const DUMMY_WHITESPACE_INVITEE_EMAIL = ' JohnDoe@amazon.com '
export const DUMMY_WHITESPACE_INVALID_INVITEE_EMAIL = ' JohnDoe@amazon.com k '
export const DUPLICATE_ERROR_EMAIL = 'Test@amazon.com'
export const MOCKED_LOGGED_IN_USER_ID = 'mockedUserIdMary'
export const MOCKED_LOGGED_IN_USER_NAME = 'Mary Major'
export const DUMMY_INVITE_TOKEN = 'abc123'
export const ERROR_INVITE_TOKEN = 'error'
export const MODAL_CLOSE = 'Close modal'
export const MODAL_ERROR_CLOSE = 'Dismiss message'
export const SKELETON_NUM_ROW = 6
export const MOCK_50 = 50
export const MOCK_2 = 2
export const MOCK_0 = 0
